var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\nGooGhywoiu9839t543j0s7543uw1 - pls add hi@weap.io to GA account UA-154798146-1 with ‘Manage Users and Edit’ permissions - date 2020/01/21\n")])}
var staticRenderFns = []

export { render, staticRenderFns }